import { finalExp, initialExp } from 'utils/validation'
import ArrowBtn from 'components/buttons/ArrowBtn'
import BackBtn from 'components/buttons/BackBtn'
import Input from 'components/inputs/Input'
import Popup from 'components/popups/Popup'
import React, { useState } from 'react'
import { LoginForm } from '..'
import './style.scss'

type Errors = Record<string, string>
interface LoginFormPopupProps {
  isSending: boolean
  loginForm: LoginForm
  login: (form: LoginForm) => void
}

const LoginFormPopup: React.FC<LoginFormPopupProps> = ({ isSending, loginForm, login }) => {
  const [errors, setErrors] = useState<Errors>({})
  const [form, setForm] = useState<LoginForm>(loginForm)

  const validateForm = () => {
    const isPhoneOk = form.phone.match(finalExp.phone)
    const isPinOk = form.pin.length > 3
    if (isPhoneOk && isPinOk) {
      if (Object.keys(errors).length > 0) setErrors({})
      login(form)
    } else {
      const newErrors: Errors = {}
      if (!isPhoneOk) newErrors.phone = form.phone ? 'Niewłaściwy numer telefonu' : 'Wpisz numer telefonu'
      if (!isPinOk) newErrors.pin = form.pin ? 'Za krótki pin' : 'Wpisz pin'
      setErrors(newErrors)
    }
  }

  return (
    <Popup>
      <div className='loginForm__popup'>
        <div className='popup__title'>
          <div>Zaloguj się</div>
        </div>
        <div className='popup__form'>
          <Input
            name='phone'
            label='Numer telefonu'
            value={form.phone}
            warning={errors.phone}
            placeholder='Wpisz numer telefonu'
            changeHandler={e => {
              const { value } = e.target
              if (!value || value.match(initialExp.phone)) setForm(prev => ({ ...prev, phone: value }))
            }}
          />
          <Input
            name='pin'
            type='password'
            label='PIN'
            value={form.pin}
            warning={errors.pin}
            placeholder='Wpisz PIN'
            changeHandler={e => {
              const { value } = e.target
              if (!value || value.length < 7) setForm(prev => ({ ...prev, pin: value }))
            }}
          />
        </div>
        <div className='popup__buttons'>
          <ArrowBtn
            enlarged
            text='Zaloguj'
            isLoading={isSending}
            action={validateForm}
          />
          <BackBtn />
        </div>
      </div>
    </Popup>
  )
}

export default LoginFormPopup